<template>
  <div class="h-full">
    <div v-if="dataHistory.length != 0">
      <a-list item-layout="vertical" size="large" :split="false" :pagination="pagination" :data-source="dataHistory">
        <a-list-item slot="renderItem" key="item.id" slot-scope="item" class="px-0 pb-10">
          <a-card :bordered="false" class="mb-0 card-billing-info" :bodyStyle="{ padding: '10px 24px' }" style="background: #f0f2f5;">
            <div class="col-info">
              <a-descriptions :column="1">
                <template slot="title">
                  <p class="mb-0">
                    Type :
                    <span class="text-capitalize">{{ item.absence_type }}</span>
                  </p>
                  <small
                    >Status :
                    <a-tag :color="item.status === 'approve' ? '#87d068' : ''" class="text-capitalize">{{
                      item.status
                    }}</a-tag></small
                  >
                </template>
                <a-descriptions-item class="mt-0">
                  <span class="mr-10 text-muted">Start</span
                  >{{ moment(item.start_date).format("DD / MM / YYYY") }}
                  <span class="mr-10 text-muted ml-10">End</span
                  >{{ moment(item.end_date).format("DD / MM / YYYY") }}
                </a-descriptions-item>
                <a-descriptions-item
                  class="mt-10"
                  label=""
                  >
                    <p v-if="item.remark && !['null', '-'].includes(item.remark)" class="font-web mt-0 mb-5">{{ item.remark }}</p>
                    <p v-if="item.detail && !['null', '-'].includes(item.detail)" class="font-web mt-0 mb-0" v-html="item.detail.toString().replace('_:::_','&nbsp;&nbsp;&nbsp;').replace('::','&nbsp;')"></p>
                  </a-descriptions-item
                >
              </a-descriptions>
            </div>
            <div class="col-action">
              <h6 class="mb-0">
                {{ item.absence_amount }} <span class="text-muted">Days.</span>
              </h6>
            </div>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
    <div v-else>
      <a-empty>
        <span class="font-weight-bold" slot="description">
          I can't find the record for submitting your fiscal year
        </span>
      </a-empty>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    FiscalYear: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      dataHistory: [],
      pagination: {
        pageSize: 4,
      },
    };
  },
  watch: {
    FiscalYear(val) {
      this.getHistoryAbsence();
    },
  },
  mounted() {
    this.getHistoryAbsence();
  },
  methods: {
    async getHistoryAbsence() {
      this.dataHistory = [];
      let startDateMont = `${Number.parseInt(this.FiscalYear) - 1}-10-01`;
      let endDateMont = `${this.FiscalYear}-09-30`;
      try {
        const res = await this.$http.get(
          `/hri/leave_of_absence/?timestart=${startDateMont}&timeend=${endDateMont}`
        );
        if (res.status === 200) {
          this.dataHistory = res.data.map((item) => ({ ...item }));
          this.dataHistory.sort((a, b) => {
            return b.id - a.id;
          });
        }
      } catch (error) {}
    },
  },
};
</script>